import React, { useEffect } from "react";
import { InputPadrao, LabelPadrao, TextAreaPadrao } from "../../../components/Base";
import { Form } from "antd";
import InputMask from "../../../components/InputMask";
import Switch from "@material-ui/core/Switch";
import SelectFiltros from "../../../components/Selects/SelectFiltros";
import BtnBuscarCnpj from "./BtnBuscarCnpj";

export default function PessoaForm({ object, setObject, tipoPlanoConta, setTabIndexExterno, tabIndex = 0 }) {
  useEffect(() => {
    if (!!setTabIndexExterno)
      setTabIndexExterno(tabIndex + 9);
  }, []);

  return <div>
    <div style={{ display: "flex" }}>
      <div style={{ width: "10%" }}>
        <LabelPadrao>Código</LabelPadrao>
        <InputPadrao value={object.codigo} disabled />
      </div>
      <div style={{ width: "40%", margin: "0 10px" }}>
        <LabelPadrao>Nome / Razão Social</LabelPadrao>
        <Form.Item name="razaoSocial" rules={[{ type: "string", message: "Insira o nome/razão social", required: true, whitespace: true }]}>
          <InputPadrao data-cy="input-razao" placeholder="Insira o Nome/razão social" onChange={e => setObject({ ...object, razaoSocial: e.target.value })} maxLength={60} tabIndex={tabIndex + 1} />
        </Form.Item>
      </div>
      {!!tipoPlanoConta && <div style={{ width: "25%", marginRight: 10 }}>
        <SelectFiltros dataCy="select-grupoconta" title="Plano de contas" modelo="grupoconta" tipo={tipoPlanoConta} placeholder="Selecione plano de contas" value={object.idPlanoConta} onChange={v => setObject({ ...object, idPlanoConta: v })} allowClear tabIndex={tabIndex + 2} />
      </div>}
      {object.isCliente && <div style={{ width: "25%", marginRight: 10 }}>
        <SelectFiltros dataCy="select-tipo" placeholder="Selecione o tipo" title="Tipo" modelo="pessoaTipo" value={object.idPessoaTipo} onChange={v => setObject({ ...object, idPessoaTipo: v })} tabIndex={tabIndex + 3} />
      </div>}
      <div>
        <LabelPadrao>Ativo</LabelPadrao>
        <Switch data-cy="switch-ativo" color="primary" checked={object.isAtivo} onChange={() => setObject({ ...object, isAtivo: !object.isAtivo })} />
      </div>
    </div>

    <div style={{ display: "flex" }}>
      <div style={{ width: "50%" }}>
        <LabelPadrao>Nome fantasia</LabelPadrao>
        <InputPadrao maxLength={200} data-cy="input-fantasia" placeholder="Insira o nome fantasia" value={object.fantasia} onChange={e => setObject({ ...object, fantasia: e.target.value })} tabIndex={tabIndex + 4} />
      </div>
      <div style={{ width: "25%", margin: "0 10px", marginTop: -8 }}>
        <LabelPadrao noMargin>
          <span style={{ marginRight: object.isPessoaFisica ? 0 : 5 }}>{object.isPessoaFisica ? "CPF" : "CNPJ"}</span>
          {!object.isPessoaFisica && <BtnBuscarCnpj cnpj={object.cpfCnpj} onOk={v => {
            const values = {
              ...object,
              razaoSocial: v.nome,
              fantasia: v.fantasia,
              numero: v.numero,
              cep: v.cep,
              telefone: v.telefone,
              bairro: v.bairro,
              logradouro: v.logradouro,
              uf: v.uf,
              cidade: v.localidade,
              codigoIbge: v.ibge,
              inscricaoEstadual: v.ie,
              telefoneFixo: v.telefone,
              complemento: v.complemento
            };
            setObject(values);
          }} />}
          <Switch color="primary" checked={object.isPessoaFisica} onChange={() => setObject({ ...object, isPessoaFisica: !object.isPessoaFisica, inscricaoEstadual: null })} />
        </LabelPadrao>

        {object.isPessoaFisica ? <Form.Item name="cpfCnpj" rules={[{ type: "string", message: "Insira o cpf", pattern: /([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/g, whitespace: true, }]}>
          <InputMask value={object.cpfCnpj} onChange={e => setObject({ ...object, cpfCnpj: e.target.value })} data-cy="input-cpfCnpj" placeholder="Insira o CPF" mask="999.999.999-99" tabIndex={tabIndex + 5} />
        </Form.Item> :
          <Form.Item name="cpfCnpj" rules={[{ type: "string", message: "Insira o cnpj", pattern: /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})/g, whitespace: true, }]}>
            <InputMask value={object.cpfCnpj} onChange={e => setObject({ ...object, cpfCnpj: e.target.value })} data-cy="input-cpfCnpj" placeholder="Insira o CNPJ" mask="99.999.999/9999-99" tabIndex={tabIndex + 5} />
          </Form.Item>}
      </div>
      <div style={{ width: "25%" }}>
        <LabelPadrao>Inscrição estadual</LabelPadrao>
        <InputPadrao
          maxLength={20}
          data-cy="input-insc"
          placeholder="Insira a inscrição estadual"
          value={object.inscricaoEstadual}
          onChange={e => setObject({ ...object, inscricaoEstadual: e.target.value })}
          disabled={object.isPessoaFisica}
          tabIndex={tabIndex + 6}
        />
      </div>
    </div>

    <div style={{ display: "flex" }}>
      <div style={{ width: "25%" }}>
        <LabelPadrao>Telefone fixo</LabelPadrao>
        <InputMask data-cy="input-telefoneFixo" placeholder="Telefone fixo" mask="(99) 9999-9999" value={object.telefoneFixo} onChange={e => setObject({ ...object, telefoneFixo: e.target.value })} tabIndex={tabIndex + 7} />
      </div>

      <div style={{ width: "25%", margin: "0 10px" }}>
        <LabelPadrao >Telefone celular</LabelPadrao>
        <InputMask
          data-cy="input-telefoneCelular"
          placeholder="Telefone celular"
          mask="(99) 99999-9999"
          value={object.telefoneCelular}
          onChange={e => setObject({ ...object, telefoneCelular: e.target.value })}
          tabIndex={tabIndex + 8}
        />
      </div>


      <div style={{ width: "50%" }}>
        <LabelPadrao>Email</LabelPadrao>
        <InputPadrao maxLength={500} data-cy="input-email" placeholder="Insira o email" value={object.email} onChange={e => setObject({ ...object, email: e.target.value })} tabIndex={tabIndex + 9} />
      </div>
    </div>

    <div style={{ display: "flex", marginTop: 10 }}>
      <div style={{ width: "50%", marginRight: 10 }}>
        <LabelPadrao>Nome responsável</LabelPadrao>
        <InputPadrao maxLength={50} placeholder="Insira o nome responsável" value={object.nomeResponsavel} onChange={e => setObject({ ...object, nomeResponsavel: e.target.value })} tabIndex={tabIndex + 10} />
      </div>

      <div style={{ width: "50%" }}>
        <LabelPadrao>Email responsável</LabelPadrao>
        <InputPadrao maxLength={500} placeholder="Insira o email responsável" value={object.emailResponsavel} onChange={e => setObject({ ...object, emailResponsavel: e.target.value })} tabIndex={tabIndex + 11} />
      </div>
    </div>

    <div style={{ display: "flex", marginTop: 10 }}>
      <div style={{ width: "50%", marginRight: 10 }}>
        <LabelPadrao>Nome financeiro</LabelPadrao>
        <InputPadrao maxLength={50} placeholder="Insira o nome financeiro" value={object.nomeFinanceiro} onChange={e => setObject({ ...object, nomeFinanceiro: e.target.value })} tabIndex={tabIndex + 12} />
      </div>

      <div style={{ width: "50%" }}>
        <LabelPadrao>Email financeiro</LabelPadrao>
        <InputPadrao maxLength={500} placeholder="Insira o email financeiro" value={object.emailFinanceiro} onChange={e => setObject({ ...object, emailFinanceiro: e.target.value })} tabIndex={tabIndex + 13} />
      </div>
    </div>

    <LabelPadrao>Observação</LabelPadrao>
    <TextAreaPadrao data-cy="txt-obs" placeholder="Insira a observação" value={object.observacao} onChange={e => setObject({ ...object, observacao: e.target.value })} tabIndex={tabIndex + 10} />
  </div>;
}
